import { render, staticRenderFns } from "./JtSearchOwnershipChange.vue?vue&type=template&id=68c80423&scoped=true"
import script from "./JtSearchOwnershipChange.vue?vue&type=script&lang=js"
export * from "./JtSearchOwnershipChange.vue?vue&type=script&lang=js"
import style0 from "./JtSearchOwnershipChange.vue?vue&type=style&index=0&id=68c80423&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c80423",
  null
  
)

export default component.exports